var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTurkey = function SvgTurkey(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10Z",
    fill: "#ED4C5C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m15.1 14.333.033-1.8-1.8-.533 1.8-.533-.033-1.8 1.1 1.433 1.8-.533L16.9 12l1.1 1.433-1.8-.533-1.1 1.433Z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4 16c-2.2 0-3.967-1.8-3.967-4S10.2 8 12.4 8c.833 0 1.6.267 2.267.7A4.938 4.938 0 0 0 10.933 7C8.2 7 6 9.233 6 12s2.2 5 4.933 5c1.5 0 2.834-.667 3.734-1.7-.634.433-1.4.7-2.267.7Z",
    fill: "#fff"
  })));
};
export default SvgTurkey;